import React from 'react';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

function Row(props) {
  const [open, setOpen] = React.useState(false);

  const [cleanedData, setCleanedData] = React.useState({})

  const cleanData = () => {
    let groupedData = {};
  
    props.weekData.forEach(item => {
      const name = item.FullName.trim().replace(/\s+/g, ' ');
      if (!groupedData[item.Date]) {
        groupedData[item.Date] = {};
      }
      groupedData[item.Date][name] = "Yes";
    });
  
    // The sorting now occurs directly in the state update function
    setCleanedData(prevData => {
      // Convert the object keys (the dates) into an array and sort it
      const sortedKeys = Object.keys(groupedData).sort((a, b) => {
        const dateA = new Date(a.split('/').reverse().join('/'));
        const dateB = new Date(b.split('/').reverse().join('/'));
        return dateA - dateB;
      });
  
      // Map the days of the week
      const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  
      // Append the day of the week to the sorted date keys
      const sortedDataWithDays = sortedKeys.reduce((acc, date) => {
        const formattedDate = new Date(date.split('/').reverse().join('/'));
        const dayName = daysOfWeek[formattedDate.getDay()];
        const newKey = `${dayName}, ${date}`;
        acc[newKey] = groupedData[date];
        return acc;
      }, {});
  
      return sortedDataWithDays;
    });
  };

  React.useEffect(() => {
    cleanData()
  }, [props.weekData])

  const allNames = [...new Set(props.weekData.map(item => item.FullName.trim().replace(/\s+/g, ' ')))];

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell sx={{ width: "60px", marginRight: "0px", paddingRight: "0px" }}>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton >
        </TableCell>
        <TableCell sx={{ marginLeft: "0px", paddingLeft: "0px" }}>
          <Typography fontWeight="bold">
            Submissions
          </Typography>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    {allNames.map((name, idx) => (
                      <TableCell key={name} sx={{ fontWeight: "bold" }} align='center'>{name}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Object.entries(cleanedData).map(([date, names], idx) => (
                    <TableRow key={date}>
                      <TableCell component="th" scope="row" sx={{ fontWeight: "bold"}} >
                      <span style={{color:"tomato"}}>{date.split(" ")[0]}</span>
                      &nbsp;
                      <span>{date.split(" ")[1]}</span>
                      </TableCell>
                      {allNames.map(name => (
                        <TableCell key={name} align='center'>{names[name] ? <CheckIcon sx={{ color: "green" }} /> : <CloseIcon sx={{ color: "lightgrey" }} />}</TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default function ENGTimesheetsSubmissions({ weekData }) {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table">
        <TableBody>
          <Row weekData={weekData} />
        </TableBody>
      </Table>
    </TableContainer>
  );
}